
import React, { Component } from 'react';
import { connect } from 'react-redux';

import SelectionTab from '../../../../../components/ZUILib/SelectionTab2';
import DownloadableFile from '../components/downloadableFile';
import DownloadPDFWithoutPreview from '../../../../../components/DownloadPDFWithoutPreview';
import pdfUtil from '../../../../../utils/PDFUtil';
import commonUtil from '../../../../../utils/commonUtil';
import DocumentsPDF from './DocumentsPDF';
import RadioDropDown from '../../../../../components/ZUILib/RadioDropDown';
import GiftListConfigureWapModal from '../../../../eventManagement/page/GiftList/wapComponents/GiftListConfigureWapModal';
import InputButton from '../../../../../components/ZUILib/InputButton';
import Accordion from '../../GiftList/components/Accordion';
import RadioButton from '../../../../../components/ZUILib/RadioButton';
import ModalPopover from '../../../../../components/ZUILib/ModalPopover';
import _ from 'lodash';
import { closeWapModalIcon } from '../../../../../components/NewHeader/Header/svgIcons';
import EmptyGiftListIndicator from '../../GiftList/components/EmptyGiftListIndicator';
const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
const pageName = 'giftListGuestView';
const GIFTS_PER_PAGE = channel === constChannels.WAP ? '30' : '52';

class HeaderContent extends Component {
  constructor(props) {
    super(props);
    this.categoryID = '';
    this.price = '';
    this.currentPage = this.props.currentPageDownPagination;
   this.state = {
      selectedItem: "Ascending",
      isSearchForId: "Ascending",
      selectedCategory : '',
      category : {},
      dropdown : false,
      selectedFilter:false
    };
  }

  handleChange = (option) => {
    // this.filterAndSorting(option);
    this.props.handlePriceFilterChange(option.id);
    this.setState({ selectedItem: option.id });
  };

  filterAndSorting = (option) => {
    // this.categoryID = this.categoryTypeFilter.getID();
    this.price = option?.id || this.sortProductByPrice.getID();

    this.props.getGiftListGuestView(this.props.eventId, (this.props.priceFilter || ''), (this.props.categoryId || ''), '1', 'false', GIFTS_PER_PAGE);
  }

  onPageChange = (value) => {
    this.props.getGiftListGuestView(this.props.eventId, (this.props.priceFilter || ''), (this.props.categoryId || ''), (value).toString(), 'false', GIFTS_PER_PAGE);
  }

  setGifteeName = (gifteeId, gifteeName) => {
    const selectedGifteeId = gifteeId;
    this.props.onSetGifteeName(selectedGifteeId);
    document.querySelector('#selectedPersonName span').innerText = gifteeName;
    document.querySelector('#dropdown').classList.remove('open');
    document.removeEventListener('click', this.handleOutsideClick, true);
  }
  
   handleCloseFilterModal = (e) => {
     const isFiltered = this.state.selectedFilter;
     if(!isFiltered){
       this.setState({selectedCategory : '' ,category : {}})
     }
     this.filterModal.handleHide();
   }

  handleOutsideClick = (e) => {
    if (!this.celebratedListDiv.contains(e.target)) {
      this.selectGifteePersonDropdown();
    }
  }

  selectGifteePersonDropdown = () => {
    if (document && typeof document !== 'undefined') {
      const one = document.getElementById('dropdown');
      if (one.className === 'btn-group') {
        document.querySelector('#dropdown').classList.add('open');
        document.addEventListener('click', this.handleOutsideClick, true);
      } else {
        one.classList.remove('open');
        event.stopPropagation();
        document.removeEventListener('click', this.handleOutsideClick, true);
      }
    }
  }

  handlePDFDownload = () => {
    this.props.getGiftListGuestView(this.props.eventId, (this.props.priceFilter || ''), (this.props.categoryId || ''), String(this.props.currentPageDownPagination) , 'false', GIFTS_PER_PAGE).then((response) => {
      if (response.status.status === 'success') {
        const downloadableContent = (
          <DownloadPDFWithoutPreview pageName printingDate={this.props.printingDate} download>
            <DownloadableFile
              categoryItemsInfo={response.categoryItemsInfo}
              labels={this.props.labels}
              eventName={this.props.eventName}
              eventDate={this.props.eventDate}
              eventType={this.props.eventType}
              printingDate={this.props.printingDate}
              eventId={this.props.eventId}
              itemsCount={this.props.itemsCount}
            />
          </DownloadPDFWithoutPreview>
        );
        pdfUtil.attachToDom(downloadableContent, pageName);
      }
    });
  }

  handlePrint = () => {
    this.props.getGiftListGuestView(this.props.eventId, (this.props.priceFilter || ''), (this.categoryID || ''), (this.currentPage).toString(), 'false', GIFTS_PER_PAGE).then((response) => {
      if (response.status.status === 'success') {
        const printContent = (
          <DownloadPDFWithoutPreview
            pageName
            printingDate={this.props.printingDate}
          >
            <DownloadableFile
              categoryItemsInfo={this.props.categoryItemsInfo}
              labels={this.props.labels}
              eventName={this.props.eventName}
              eventDate={this.props.eventDate}
              eventType={this.props.eventType}
              printingDate={this.props.printingDate}
              eventId={this.props.eventId}
              itemsCount={this.props.itemsCount}
            />
          </DownloadPDFWithoutPreview>
        );
        pdfUtil.attachToDomForPrint(printContent, pageName);
      }
    });
  }

  clearAllFilter = () => {
    this.sortProductByPrice?.clearSelectedData?.();
    this.categoryTypeFilter?.clearSelectedData?.();
  };

  setCategory = (id) => {
    this.setState({selectedCategory : id })
  }
  handleSaveFilters = () => {
   this.props.handleCategoryChange(this.state?.category?.id);
   this.setState({selectedCategory:this.state?.category?.id , selectedFilter:true})
   this.filterModal.handleHide();
  }
  closeModal = () =>{
    this.filterModal.handleHide();
    // this.props.handleCategoryChange('Todas las categorías')
    // this.setState({selectedCategory : ''})
  }
  handleClearFilters = (close) => {
    this.props.handleCategoryChange('Todas las categorías')
    this.setState({selectedCategory : '' ,category : {} , selectedFilter:false})
    close && this.filterModal.handleHide();
  }
handleCategoryChange = (category) => {
  let particularCategory = _.find(this.props.guestViewGiftListData.guestViewGiftList.categoryList, ['id', category?.id]);
  
  this.setState({
    // selectedCategory : category,
    category : category
  })
}
  render() {

    //
          // const options = ["Apple", "Banana", "Cherry"];
    const { selectedItem } = this.state;

    //
    const guestViewGiftList = this.props.guestViewGiftListData;
    const guestViewGiftListData = guestViewGiftList.guestViewGiftList;
    const ascendingToDescending = commonUtil.getLabel(this.props.labels.EventAdminPage, 'adminpage.regalosregistrados.priceSort.lowest.wap.label').split(':')[1];
    const descendingToAscending = commonUtil.getLabel(this.props.labels.EventAdminPage, 'adminpage.regalosregistrados.priceSort.wap.label').split(':')[1];
    const categoryListDropDown = {
      name: 'categoryList',
      options: [],
    };

    if (guestViewGiftListData && guestViewGiftListData.categoryList) {
      const newSet = new Set();
      guestViewGiftListData.categoryList.filter((category) => {
        if (newSet.has(category.name)) {
          return false;
        }
        newSet.add(category.name);
        return true;
      }).map(category =>
        categoryListDropDown.options.push({
          id: category.id,
          value: category.name,
          labelResourceId: 'category.name',
          disabled: false,
        }),
      );
    }
    const PriceBasedSorting = {
      options: [{
        id: 'Ascending',
        value: 'Menor precio',
        labelResourceId: 'LowToHigh',
        disabled: false,
      }, {
        id: 'Descending',
        value: 'Mayor precio',
        labelResourceId: 'HighToLow',
        disabled: false,
      }],
    };

    const FilterArticleButton = {
          themeColor: this.props.selectedTheme?.color_500 || '#000',
          type: 'button',
          id: 'filterArticle',
          style: 'mobileWhiteButton',
          value: 'Filtrar',
          filteredProducts : this.state.selectedCategory ? 1 : '',
          activeCategory: !_.isEmpty(this.state.selectedCategory),
          // disabled: !registeredItemsFound,
          // cssStyle: { opacity: registeredItemsFound ? '100%' : '33%' },
          beforeIconClass: 'icon-tune',
          guestView : true,
          onClickHandler: () => this.filterModal.handleShow(),
        };
     const SaveButtonforFilter = {
      id: 'saveFilter',
      themeColor: this.props.selectedTheme?.color_800 || '#000',
      type: 'button',
      value: `Ver ${this.state?.category?.totalItems || ''} artículos`,
      autoFocus: false,
      style: `customButtonGuardar-new ${!this.state.selectedCategory ? 'btn widthFull' : ''}`,
      onClickHandler: this.handleSaveFilters,
      disabled: !this.state?.category?.id
    };
    const ClearButtonforFilter = {
      themeColor: this.props.selectedTheme?.color_800 || '#000',
      id: 'clearFilterWap',
      type: 'button',
      value: "Limpiar filtros",
      autoFocus: false,
      style: 'customButtonLimpiar-new',
      onClickHandler: () => this.handleClearFilters(true),
    };
      
          const accordianFilterData = 
              {
              title: commonUtil.getLabel(this.props?.labels?.EventAdminPage, 'adminpage.regalosregistrados.category.filter.title.label'),
            content: (
                  <div className="category-radio-group">
                    {guestViewGiftListData.categoryList?.map((ele, idx) => (
                      <div key={idx} className="radio-label-wrapper-new">
                        <span>{ele.name}</span>
                        <RadioButton
                          id={`category-${idx}`}
                          name="categoryFilter"
                          value={ele.id}
                          displayName=""
                          radioCssClass="custom-radio"
                          checked={this.state?.category?.id === ele.id || false}
                          onChangeFunction={() => this.handleCategoryChange(ele)}
                        />
                      </div>
                    ))}
                  </div>
        
                ),
            showOnLoad: true,
            }

    return (
      <React.Fragment>
        { (guestViewGiftListData && guestViewGiftListData.itemsCount != 0) ? 
        (<div>
          <div className="clearfix" />
          <div className="col-md-12 col-sm-12" style={{ borderBottom: '0', marginTop: '20px' }}>
            <div style={{ display: 'flex', gap: '25px', alignItems: 'center', justifyContent: 'space-between' }}>
              {/* <div style={{ width: '20%' }}>
                <SelectionTab
                  classname="cSelect"
                  options={PriceBasedSorting.options}
                  optionText={'value'}
                  optionValue={'value'}
                  isCaptionDisabled={false}
                  handleSelectedOption={this.filterAndSorting}
                  inlineStyleDropdown={{ color: '#333333' }}
                  ref={ref => this.sortProductByPrice = ref}
                />
              </div> */}
              {/* <div style={{ width: '20%' }}>
                <SelectionTab
                  id={categoryListDropDown.id}
                  classname="cSelect"
                  optionCaption="Todas las categorías"
                  options={categoryListDropDown.options}
                  isCaptionDisabled={false}
                  optionText={'value'}
                  optionValue={'value'}
                  handleSelectedOption={this.filterAndSorting}
                  inlineStyleDropdown={{ color: '#333333' }}
                  ref={ref => this.categoryTypeFilter = ref}
                />
              </div> */}
              {(channel === 'web') ? <RadioDropDown
                 isGiftList={true}
                options={PriceBasedSorting.options}
                selectedOption={selectedItem}
                onChange={this.handleChange}
                  placeholder={`Ordenar por\u200A: ${selectedItem == "Ascending" ? ascendingToDescending : descendingToAscending}`}
              /> : null}
                { this.state.shareModal  && <GiftListConfigureWapModal
                      bodyClassName="evnt-modal-body-giftList"
                      isHeader={false}
                    > 
                  <div className="evnt-modal-header-giftList">
                   <h4 className="evnt-modal-title-giftList"> {commonUtil.getLabel(this.props.lables, 'Ordener')}</h4>
                     <button className="evnt-modal-close-icon-giftList" aria-label="Cerrar modal" onClick={() => this.setState({ shareModal: false })}>
                      {closeWapModalIcon}
                     </button>
                   </div>
                      <div className='evnt-modal-body-giftList-wrapper'>
                       {PriceBasedSorting && PriceBasedSorting.options.length > 0 ?
                        (PriceBasedSorting.options.map(
                          (option, index) =>  <div key={index} className="evnt-modal-option-sorting" 
                          // this.filterRecords(option.id,'eventType')
                           > 
                        <label htmlFor="btnRadioForSorting" className='event_label_list'>
                             {option.value}
                       </label>
                         <input
                           name="btnRadio"
                           value="sorting"
                           type="radio"
                           id="btnRadioForSorting"
                          checked={this.state.isSearchForId == option.id}
                          onChange={event => this.setState({ isSearchForId: option.id })}
                         />
                        </div>)): null}
                      </div>
                        <div className='event_modal_footer'>
                          <button className='evnt-modal-close-btn-giftList' style={{background: this.props.selectedTheme?.color_800 || '#000',
                            border: 'none'
                          }} onClick={() => { this.setState({ shareModal: false }); this.props.handlePriceFilterChange(this.state.isSearchForId) }}>Aplicar cambio</button>
                        </div>
                          
                    </GiftListConfigureWapModal>}

              {channel == 'web' && <div className='downloadpdf'>
                <DocumentsPDF
                  handlePDFDownload={this.handlePDFDownload}
                  handlerSharelink={this.props.setCopyToClipboard}
                  handlePrint={this.handlePrint}
                  // hidePdf={channel == "web" ? true :false}
                />
              </div>
            }
            
            </div>
          </div>
          {
            channel == 'wap' && <div className=''>
                <div className='row icons_wap_list_container'>
                  <div className='col-xs-12 downloadpdf' style={{marginBottom :'10px'}}>
                <DocumentsPDF
                  handlePDFDownload={this.handlePDFDownload}
                  handlePrint={this.handlePrint}
                  isWap = {true}
                  // hidePdf={channel == "web" ? true :false}
                />
              </div>
                  </div>
                <div className='row btns_container_wap_guest_list'>
                  <div className="col-xs-2 filter_btn_wap_list">
                  <InputButton style={{ width: '74px' }} buttonAttr={FilterArticleButton} />
                </div>
                <div className='col-xs-7 price_sorting_btn_wap_list'>
                   <div className='sorting_wap_list' style={{ width: 'max-content' }} onClick={() => this.setState({ shareModal: true })}>
                  <img src={commonUtil.getAssetURL() + '/images/swap_vert.svg'} className='selection_swap_img' />
                   <span className='selection_sort_wap'>{`Ordenar: ${ this.state.isSearchForId == "Ascending" ? "Menor" : "Mayor"} a  ${ this.state.isSearchForId == "Ascending" ? "mayor" : "menor"} precio`} </span> 
                   
                </div>
                  </div>
                </div>
               

            </div>
          }
           <ModalPopover
            modalId="filterModal" dismiss="false" isModal="true" isWapFull="true"
            ref={filterModal => this.filterModal = filterModal}
          >
             <div className="row headOptionModal" style={{padding:'10px',borderBottom : '1px solid #EBEBEB'}}>
                <div className="col-xs-8"> <span className="titleOptionModal"> Filtrar </span></div>
                <div className="col-xs-4 text-right closeOptionModal" onClick={(e) => this.handleCloseFilterModal(e)}><img
                  src={commonUtil.getAssetURL() + "/images/close.svg"}
                  alt=""
                  className="icon_vozcliente"
                /></div>
              </div>

            <div className="wrap wrapWap">
              <div className="filter-container">
                {this.state?.category?.name &&
                  <><div className="filter-tag">
                    <span>{this.state?.category?.name}</span>
                    <span
                      className="remove-tag"
                      onClick={() => this.handleClearFilters(false)}
                    >
                      ×
                    </span>
                  </div>
                  <div className='divider-category-filter'></div>
                  </>
                }
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <div className='row'>
                    <div className='mode_filter_change' style={{ padding: '0px 32px'}}>
                      <p className='categories-text'>{accordianFilterData.title} <span onClick={() => this.setState({dropdown:!this.state.dropdown})} class="pull-right dropdown-icon-margin"><img
                                    src={commonUtil.getAssetURL() + `/images/${this.state.dropdown ? "expand_more" : "expand_less" }.svg`}
                                    alt="Expand More"
                                    className="expand_drop_icon"
                                  /></span></p> 
                        <div className='categories-list'>
                        {!this.state.dropdown && accordianFilterData.content}
                        </div>
                      {/* <Accordion items={accordianFilterData} alwaysOpen={true}/> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 padding-zero">
                <div className="filter-button-group">
                  {this.state.selectedCategory && (
                    <InputButton 
                      buttonAttr={ClearButtonforFilter}
                    />
                  )}
                  <InputButton 
                    buttonAttr={SaveButtonforFilter}
                  />
                </div>
              </div>
            </div>
          </ModalPopover>
           <div className='productsCount_container' style={{float:'right',padding:'10px 15px'}}>
                <p style={{ fontWeight: 'bold' }}>
                  {guestViewGiftListData && guestViewGiftListData.currentPage == guestViewGiftListData.totalPages  ? guestViewGiftListData.totalRecords : guestViewGiftListData.totalRecordsShowed}
                  {' de '}
                  {guestViewGiftListData && guestViewGiftListData.itemsCount ? guestViewGiftListData.itemsCount : ''}
                  {' '}
                  <span style={{ fontWeight: 'normal' }}>productos</span>
                </p>
              </div>
        </div>
        ) : <EmptyGiftListIndicator giftList="guestView" style={{ padding: '3rem 0 0' }} />
        }
      </React.Fragment>
    );
  }
}

export default HeaderContent;
